
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var LeaveJobApplyPage = Vue.extend({})
Vue.component('leaveJobApply-page', LeaveJobApplyPage)

export default {
  name: 'LeaveJobApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/hr/leaveJobApply.vue